import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GroupsCustomer.css';
import { useSelector } from 'react-redux';
import { modulePermissions } from '../../../../../utils/modulePermissions';
// Icons
import eyeOn from '../../../../../assets/tokens/eyeOn.png';
import editIcon from '../../../../../assets/editIcon.png';
import editInactive from '../../../../../assets/tokens/editInactive.png';
import toggleActive from '../../../../../assets/toggleActive.png';
import toggleInactive from '../../../../../assets/toggleInactive.png';
import trashActive from '../../../../../assets/tokens/trashActive.png';
import trashInactive from '../../../../../assets/tokens/trashInactive.png';
// Components
import Badge from '../../../../../components/Badge/Badge';
import Filters from '../../../../../components/Filters/Filters';
import Table from '../../../../../components/Table/Table';
//handle
import HandleResponse from '../../../../../utils/HandleResponse';
import HandleAlert from '../../../../../utils/HandleAlert';
//services
import { groupService } from '../../../../../services/Group';
//utils
import { formatDate } from '../../../../../utils/utils';

const GroupsCustomer = ({ user_id }) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [groupsData, setGroupsData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnsShare, setColumnsShare] = useState(0);
  const { searchTerm } = useSelector((state) => state.search);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filters, setFilters] = useState({});
  const [organizations, setOrganizations] = useState([]);

  useEffect(() => {
    fetchGroupsData(filters, 1);
    fetchOrganizations();
    fetchColumns();
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchGroupsData(filters, currentPage);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  const fetchOrganizations = async () => {
    try {
      const response = await groupService.getOrganizations();
      if (response.status === "success") {
        const orgOptions = response.data.map(org => ({
          label: org.name,
          value: org.id
        }));
        setOrganizations(orgOptions);
      }
    } catch (error) {
      console.error('Error fetching organizations:', error);
    }
  };

  const fetchGroupsData = async (filterValues = {}, page = 1) => {
    try {
      const status = filterValues.status ? filterValues.status.toLowerCase() : null;
      const type_organization = filterValues.type ? filterValues.type.value : null;
      const name = searchTerm ? searchTerm : null;
      let start_date = filterValues.creationDate ? filterValues.creationDate.start_date : null;
      let end_date = filterValues.creationDate ? filterValues.creationDate.end_date : null;
      const members = filterValues.members ? filterValues.members : null;

      if(start_date) start_date = start_date.split('T')[0];
      if(end_date) end_date = end_date.split('T')[0];

      const params = {
        page,
        items_per_page: 10,
        ...(status && { status }),
        ...(type_organization && { type_organization }),
        ...(name && { name }),
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(members && { members })
      };

      const response = await groupService.groupsListUser(user_id, params);
      console.log('API Response:', response);
      if(response.status === "success" && response.data && response.data.data.length > 0) {
        const data = response.data.data.map(item => ({
          ...item,
          id: item.group?.id,
          name: item.group?.name,
          status: item.group?.status,
          role: item.participant.role,
          dateAdded: formatDate(item.group?.created_at),
          dateOfGroupRegister: formatDate(item.participant?.created_at)
        }));
        setGroupsData(data);
        setTotalItems(response.data.total || response.total || data.length);
      }else{
        setGroupsData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error('Error fetching groups:', error);
    }
  };

  const fetchColumns = () => {
    let count = 1;
    const columnsData = [
      { 
        header: 'Group Name', 
        field: 'name' 
      },
      { 
        header: 'Services offered', 
        field: 'service_count',
        render: (row) => row.group?.service_count || 0
      },
      { 
        header: 'Role', 
        field: 'role' 
      },
      { 
        header: 'Date added', 
        field: 'dateAdded' 
      },
      { 
        header: 'Date of group register', 
        field: 'dateOfGroupRegister' 
      },
      {
        header: 'Status', 
        render: (row) => (
          <Badge status={row.status} />
        )
      }
    ];

    if(modulePermissions.hasClientGroupsPermission('edit')) {
      columnsData.push({
        header: '',
        render: (row) => (
          <button className="edit-btn" onClick={() => handleEdit(row)}>
            <img src={row.status !== 'deleted' ? editIcon : editInactive} alt="Edit" />
          </button>
        )
      });
      count++;
    }

    columnsData.push({
      header: '',
      render: (row) => (
        <button className="view-btn" onClick={() => handleView(row)}>
          <img src={eyeOn} alt="View" />
        </button>
      )
    });

    if(modulePermissions.hasClientGroupsPermission('activate_deactivate')) {
      columnsData.push({
        header: '',
        render: (row) => (
          <button className="edit-btn" onClick={() => AlertToggle(row)}>
            <img src={row.status === 'active' ? toggleActive : toggleInactive} alt="Toggle" />
          </button>
        )
      });
      count++;
    }

    if(modulePermissions.hasClientGroupsPermission('delete')) {
      columnsData.push({
        header: '',
        render: (row) => (
          <button className="edit-btn" onClick={() => AlertDelete(row)}>
            <img src={row.status === 'active' ? trashActive : trashInactive} alt="Delete" />
          </button>
        )
      });
      count++;
    }

    setColumns(columnsData);
    console.log('Columns share:', count);
    setColumnsShare(count);
  };

  const handleView = (row) => {
    console.log('View group:', row);
    navigate(`/customers/groups/${row.id}`, {
      state: { 
        group: row,
        action: 'view'
      }
    });
  };

  const handleEdit = (row) => {
    if(isDelete(row, true)) return;

    navigate(`/customers/groups/${row.id}`, {
      state: { 
        group: row,
        action: 'edit'
      }
    });
  };

  const AlertToggle = (row) => {
    if(isDelete(row, true)) return;

    HandleAlert.showConfirmationAlert({
      title: { text: 'Toggle', highlight: 'group' },
      message: 'Do you want to continue with the action?',
      onConfirm: () => {
        HandleAlert.hideAlert();
        handleToggleStatus(row);
      }
    });
  };

  const AlertDelete = (row) => {
    if(isDelete(row, true)) return;

    HandleAlert.showConfirmationAlert({
      title: { text: 'Delete', highlight: 'group' },
      message: 'Do you want to continue with the action?',
      onConfirm: () => {
        HandleAlert.hideAlert();
        handleDeleteStatus(row);
      }
    });
  };
  
  const handleToggleStatus = async (row) => {
    try {
      console.log(row);
      await groupService.changeStatusGroup(row.id, row.status === 'active' ? false : true);
      HandleResponse.showSuccessModal({
        title: { text: 'Toggle', highlight: 'group' },
        message: 'The group has been successfully toggled.',
        confirmText: 'Accept',
        onConfirm: () => {
          fetchGroupsData(filters, currentPage);
          HandleResponse.hideModal();
        }
      });
    } catch (error) {
      HandleResponse.showErrorModal({
        title: { text: 'Toggle', highlight: 'group' },
        message: 'An error has occurred while toggling the group.',
        confirmText: 'Understood',
        onConfirm: () => {
          HandleResponse.hideModal();
        }
      });
    }
  };

  const handleDeleteStatus = async (row) => {
    try {
      if(isDelete(row)) return;

      await groupService.deleteGroup(row.id);
      HandleResponse.showSuccessModal({
        title: { text: 'Delete', highlight: 'group' },
        message: 'The group has been successfully deleted.',
        confirmText: 'Accept',
        onConfirm: () => {
          fetchGroupsData(filters, currentPage);
          HandleResponse.hideModal();
        }
      });
    } catch (error) {
      HandleResponse.showErrorModal({
        title: { text: 'Delete', highlight: 'group' },
        message: 'An error has occurred while deleting the group.',
        confirmText: 'Understood',
        onConfirm: () => {
          HandleResponse.hideModal();
        }
      });
    }
  };

  const isDelete = (row, isToggle = false) => {
    if((row.status === 'inactive') && !isToggle) {
      HandleResponse.showErrorModal({
        title: { text: 'Inactive', highlight: 'group' },
        message: 'The group is already inactive.',
        confirmText: 'Understood',
        onConfirm: () => {
          HandleResponse.hideModal();
        }
      });
      return true;
    }else if((row.status === 'deleted') && isToggle) {
      HandleResponse.showErrorModal({
        title: { text: 'Deleted', highlight: 'group' },
        message: 'The group is already deleted.',
        confirmText: 'Understood',
        onConfirm: () => {
          HandleResponse.hideModal();
        }
      });
      return true;
    }else{
      return false;
    }
  };

  return (
    <div className="groups-customer-container">
      <div className="filters-section">
        <Filters
          filters={[
            {
              id: 'status',
              label: 'Status',
              type: 'checkbox',
              options: ['Active', 'Pending', 'Inactive']
            },
            {
              id: 'creationDate',
              label: 'Creation date',
              type: 'dateRange',
              placeholder: 'dd/mm/yyyy - dd/mm/yyyy'
            },
            {
              id: 'type',
              label: 'Select of options',
              type: 'dropdown',
              options: organizations
            },
            {
              id: 'members',
              label: 'Number of members',
              type: 'number',
              placeholder: 'Enter number of members'
            }
          ]}
          onApplyFilters={(selectedFilters) => {
            setFilters(selectedFilters);
            fetchGroupsData(selectedFilters, 1);
          }}
        />
      </div>

      <div className="table-section">
        <Table
          columns={columns}
          data={groupsData}
          currentPage={currentPage}
          totalItems={totalItems}
          columnsShare={columnsShare}
          onPageChange={(page) => {
            setCurrentPage(page);
            fetchGroupsData(filters, page);
          }}
        />
      </div>
    </div>
  );
};

export default GroupsCustomer;